import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdfaComponent } from './pdfa.component';

const routes: Routes = [
  {
    path: '',
    component: PdfaComponent,
      children: [
        {
          path: '',
          loadChildren: () =>
            import('./bank-form/bank-form.module').then((m) => m.BankFormModule),
        },
         {
          path: 'bankForm',
          loadChildren: () =>
            import('./bank-form/bank-form.module').then((m) => m.BankFormModule),
        },
        {
          path: 'returnPda',
          loadChildren: () =>
            import('./return-pda/return-pda.module').then((m) => m.ReturnPdaModule),
        },
        {
          path: 'reviewContinue',
          loadChildren: () =>
            import('./review-continue/review-continue.module').then((m) => m.ReviewContinueModule),
        },
        {
          path: 'port-agent-form',
          loadChildren: () =>
            import('../port-agent-form/port-agent-form.module').then((m) => m.PortAgentFormModule),
        },
      ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PdfaRoutingModule {}